module.exports = "<p>\r\n  accueil works!\r\n</p>\r\n"